"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmbedSDK = exports.LookerEmbedExSDK = exports.createChattyBuilder = void 0;
var chatty_1 = require("@looker/chatty");
var utils_1 = require("./utils");
var EmbedBuilderEx_1 = require("./EmbedBuilderEx");
/**
 * @hidden
 */
var createChattyBuilder = function (url) { return chatty_1.Chatty.createHost(url); };
exports.createChattyBuilder = createChattyBuilder;
var LookerEmbedExSDK = /** @class */ (function () {
    /**
     * @hidden
     */
    function LookerEmbedExSDK(
    // Allow tests to inject their own chatty implementation
    _chattyHostCreator) {
        if (_chattyHostCreator === void 0) { _chattyHostCreator = exports.createChattyBuilder; }
        this._chattyHostCreator = _chattyHostCreator;
        /**
         * @hidden
         */
        this._sessionCreated = false;
    }
    LookerEmbedExSDK.prototype.init = function (apiHost, auth) {
        this._apiHost = (0, utils_1.sanitizeHostUrl)(apiHost);
        this._auth = typeof auth === 'string' ? { url: auth } : auth;
        this._acquireSession = undefined;
        this._generateTokens = undefined;
        this._cookielessSession = undefined;
    };
    LookerEmbedExSDK.prototype.initCookieless = function (apiHost, acquireSession, generateTokens) {
        this._apiHost = (0, utils_1.sanitizeHostUrl)(apiHost);
        this._acquireSession = acquireSession;
        this._generateTokens = generateTokens;
        this._auth = undefined;
        this._cookielessSession = {
            generateTokensTime: 0,
        };
    };
    LookerEmbedExSDK.prototype.clearSession = function () {
        this._sessionCreated = false;
        this._createEmbedSessionPromise = undefined;
        this._createEmbedSessionPromiseResolver = undefined;
        this._generateTokensPromise = undefined;
        this._apiHost = undefined;
        this._auth = undefined;
        this._acquireSession = undefined;
        this._generateTokens = undefined;
        this._cookielessSession = undefined;
    };
    LookerEmbedExSDK.prototype.preload = function () {
        return this.createWithUrl('/embed/preload/');
    };
    LookerEmbedExSDK.prototype.createWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, (0, utils_1.extractPageTypeFromUrl)((0, utils_1.santizeEmbedUrl)(url)), '').withUrl(url);
    };
    LookerEmbedExSDK.prototype.createDashboardWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'dashboards', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createDashboardWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'dashboards', '/embed/dashboards').withId(String(id));
    };
    LookerEmbedExSDK.prototype.createExploreWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'explore', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createExploreWithId = function (id) {
        id = id.replace('::', '/'); // Handle old format explore ids.
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'explore', '/embed/explore').withId(id);
    };
    LookerEmbedExSDK.prototype.createMergeQueryWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'merge', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createMergeQueryWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'merge', '').withUrl("/embed/merge?mid=".concat(id));
    };
    LookerEmbedExSDK.prototype.createQueryWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'query', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createQueryWithId = function (model, view, qid) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'query', '').withUrl("/embed/query/".concat(model, "/").concat(view, "?qid=").concat(qid));
    };
    LookerEmbedExSDK.prototype.createLookWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'looks', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createLookWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'looks', '/embed/looks').withId(String(id));
    };
    LookerEmbedExSDK.prototype.createExtensionWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'extensions', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createExtensionWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'extensions', '/embed/extensions').withId(id);
    };
    LookerEmbedExSDK.prototype.createQueryVisualizationWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'query-visualization', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createQueryVisualizationWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'query-visualization', '/embed/query-visualization').withId(id);
    };
    LookerEmbedExSDK.prototype.createReportWithUrl = function (url) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'reporting', '').withUrl((0, utils_1.santizeEmbedUrl)(url));
    };
    LookerEmbedExSDK.prototype.createReportWithId = function (id) {
        return new EmbedBuilderEx_1.EmbedBuilderEx(this, 'reporting', '/embed/reporting').withId(id);
    };
    Object.defineProperty(LookerEmbedExSDK.prototype, "apiHost", {
        /**
         * @hidden
         */
        get: function () {
            return this._apiHost || '';
        },
        /**
         * @hidden
         */
        set: function (apiHost) {
            this._apiHost = apiHost;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerEmbedExSDK.prototype, "auth", {
        /**
         * @hidden
         */
        get: function () {
            return this._auth || { url: '' };
        },
        /**
         * @hidden
         */
        set: function (auth) {
            this._auth = auth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerEmbedExSDK.prototype, "acquireSession", {
        /**
         * @hidden
         */
        get: function () {
            return this._acquireSession || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerEmbedExSDK.prototype, "generateTokens", {
        /**
         * @hidden
         */
        get: function () {
            return this._generateTokens || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LookerEmbedExSDK.prototype, "chattyHostCreator", {
        /**
         * @hidden
         */
        get: function () {
            return this._chattyHostCreator;
        },
        enumerable: false,
        configurable: true
    });
    return LookerEmbedExSDK;
}());
exports.LookerEmbedExSDK = LookerEmbedExSDK;
var _embedSdk;
/**
 * Get the Embed SDK
 */
var getEmbedSDK = function (
/**
 * @hidden
 */
embedSdk) {
    if (embedSdk) {
        _embedSdk = embedSdk;
    }
    else if (!_embedSdk) {
        _embedSdk = new LookerEmbedExSDK();
    }
    return _embedSdk;
};
exports.getEmbedSDK = getEmbedSDK;
//# sourceMappingURL=LookerEmbedExSDK.js.map